import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { endpoint } from '../../../../environments/environment';
import { UserInfo } from '../../model/userInfo';
import { Products } from '../../model/products';
import { CacheService } from './cache.service';
import listLogMessages from 'src/app/core/constants/transaction-log-messages/transaction-log-messages.json';


@Injectable({
  providedIn: 'root',
})
export class PolicyService {

  url = endpoint.apiUrl + endpoint.apiRoute;
  listLogMessages: any = listLogMessages;

  constructor(private http: HttpClient, private _cacheService: CacheService) { }

  getUserInfo(body: any) {
    return new Promise<UserInfo[]>((resolve, reject) => {
      this.http.post(this.url + endpoint.documentApiUrl + endpoint.listarPolizas, { ...body }).subscribe((data: any) => {
        if (!data.data?.length || data.data?.length === 0) {
          reject('Hubo un error en la autenticación');
        }
        resolve(data.data);
      }, (err) => {
        reject(err);
      });
    });
  }

  async getPolicyList(body: any) {
    return new Promise<Products[]>((resolve, reject) => {
      this.http.post(this.url + endpoint.documentApiUrl + endpoint.listarPolizas, { ...body }).subscribe((data: any) => {
        if (!data.data?.length || data.data?.length === 0) {
          reject(data);
        }
        resolve(data.data);
      }, (err) => {
        reject(err);
      });
    });
  }

  registerSignature(body: any) {
    return new Promise<any>((resolve, reject) => {
      this.http.post(this.url + endpoint.documentApiUrl + endpoint.registrarFirma, { ...body }).subscribe((data: any) => {
        resolve(data.data);
      }, (err) => {
        reject(err);
      });
    });
  }

  getPdfUrl(body: any) {
    return new Promise<any>((resolve, reject) => {
      this.http.post(this.url + endpoint.documentApiUrl + endpoint.listarDetalles, { ...body }).subscribe((data: any) => {
        resolve(data.data);
      }, (err) => {
        reject(err);
      });
    });
  }

  generateOtp(): Promise<void> {

    const documentType = this._cacheService.get("typeDocumentClient")
    const document = this._cacheService.get("documentClient")
    const data = {
      securityCodeInformation: {
        idProcess: "CNL0016"
      },
      channel: {
        code: ""
      },
      alertParameters: {
        transactionCode: "",
        message: "",
        customerSegment: "INC"
      },
      identification: {
        type: documentType,
        number: document
      },
      contactDetail: {
        mobilePhone: this._cacheService.get("cellClient"),
        email: this._cacheService.get("emailClient")
      }
    };

    const log = {
      identificationNumber: document,
      identificationType: documentType,
      policyNumber: this._cacheService.get('policy')?.insurance_id || '',
      ipTransaction: this._cacheService.get('ip') || '',
      idSession: this._cacheService.get('idSession'),
      idRequest: 'generateOtp',
      description: listLogMessages.generateOtp,
    }

    return new Promise<any>((resolve, reject) => {
      this.http.post(this.url + endpoint.gestionOtpUrl + endpoint.generarOtp, { data, log }).subscribe((data: any) => {
        resolve(data);
      }, (err) => {
        reject(err);
      });
    });
  }

  validateOtp(body: any) {
    return new Promise<any>((resolve, reject) => {
      this.http.post(this.url + endpoint.gestionOtpUrl + endpoint.validarOtp, body).subscribe((data: any) => {
        resolve(data);
      }, (err) => {
        reject(err);
      });
    });
  }


}

